import _findIndex from 'lodash/findIndex';
import _property from 'lodash/property';
import { PAGE_SIZE, ROW_HEIGHT, PLACE_HOLDER_HEIGHT } from './menuList.constants';
export var getMenuHeight = function getMenuHeight(optionSize) {
  if (optionSize === 0) {
    return PLACE_HOLDER_HEIGHT;
  }
  var height = optionSize < PAGE_SIZE ? optionSize * ROW_HEIGHT : PAGE_SIZE * ROW_HEIGHT;
  return height;
};
var isOptionFocused = _property('props.isFocused');
export var getFocusedOptionIndex = function getFocusedOptionIndex(options) {
  return _findIndex(options, isOptionFocused);
};